<template>
  <div>
    <el-form label-width="180px" :model="datas" ref="form" :rules="validationRules" class="roleForm">
      <el-form-item label="角色分类" prop="pid">
<!--        <treePicker :treePicker="treePicker" style="width: 500px"></treePicker>-->
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input style="width: 500px" type="text" v-model="datas.name" placeholder="请输入角色名称" size="small" />
      </el-form-item>
      <el-form-item label="排序" prop="orderNum">
        <el-input-number v-model="datas.orderNum" :min="1" class="headName" style="width: 500px; margin-left: 0.5px" size="small"></el-input-number>
      </el-form-item>
      <el-form-item label="描述" prop="text">
        <el-input
          style="width: 500px"
          type="textarea"
          :autosize="{ minRows: 3 }"
          v-model="datas.description"
          placeholder="请输入描述，非必填"
          size="small"
        />
      </el-form-item>
      <div style="margin-top: 10px; text-align: center">
        <el-button style="width: 150px" type="primary" @click="save" size="mini">提交</el-button>
        <el-button style="width: 150px; margin-left: 10px" type="danger" @click="close()" size="mini">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    params: Object
  },
  components: {

  },
  data() {
    return {
      treeData: [],
      teamId: '',
      validationRules: {
        name: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        pid: [{ required: true, message: '角色分类不能为空', trigger: 'blur' }]
        // description: [{ required: true, message: '角色描述不能为空', trigger: 'blur' }]
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      treePicker: {
        url: `${$api_lims.role.tree}`,
        params: {},
        toLabel: 'name'
      },
      datas: {
        code: null,
        name: '',
        orderNum: 1,
        description: '',
        typeName: '',
        pid: '',
        nodeType: 'item'
      },
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: JSON.parse(sessionStorage.getItem('RoleTree'))
      },
      vali: true
    };
  },
  mounted() {
    if (this.params.id !== null) {
      this.leftForById();
    }
    if (this.params.teamId !== '') {
      this.$store.dispatch('changeNodeName', this.params.teamName);
      this.$store.dispatch('changeTreePick', this.params.teamId);
    }
    this.tree();
  },
  methods: {
    tree() {
      httpKit.post($api_lims.role.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.param.datas = res.data.data;
            this.teamId = res.data.data[0].pid;
          }
        }
      });
    },
    close() {
      this.$emit('close');
    },
    change(value) {
      if (value == null || value === 'undefined' || value === '') return;
      let par = value.children;
      if (par === '' || par === null || par === undefined) {
        this.datas.orderNum = 1;
      } else {
        this.datas.orderNum = par.length + 1;
      }
    },
    async save() {
      this.datas.pid = this.$store.state.employee.treePick;
      let res = await this.$refs.form.validate();
      if (!res) {
        return;
      }
      let loading = this.$loading({ text: '保存中，请稍后' });
      httpKit.post($api_eap.role.save, this.datas).then(res => {
        loading.close();
        if (res.data.code === '200') {
          this.$message.success('角色创建成功, 请完成菜单授权');
          this.$emit('succ');
          // 备用
          // this.$emit('roleAuth');
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    leftForById() {
      let par = { roleId: this.params.id };
      httpKit.post($api_eap.role.info, par).then(res => {
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.$store.dispatch('changeNodeName', this.params.teamName);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.roleForm {
  .el-form-item__label {
    line-height: 32px;
  }
  .el-form-item__content {
    margin-bottom: 10px;
    line-height: 32px;
    .el-input__icon {
      line-height: 32px;
    }
  }
  .el-input-number {
    width: 230px;
  }
}
</style>
